import { P2GBox } from '@parcel2go/peacock-legacy-core/dist/box';
import { P2GImage } from '@parcel2go/peacock-legacy-core/dist/image';
import { P2GLink } from '@parcel2go/peacock-legacy-core/dist/link';
import { P2GLinkGroup } from '@parcel2go/peacock-legacy-core/dist/linkgroup';
import { P2GSidePanel } from '@parcel2go/legacy-my-account-core/dist/sidepanel';
import React, { useState } from 'react';
import { ActionType, Integration } from '../services/api/types';
import IntegrationAccountsAndActions from './IntegrationAccountsAndActions';
import ActionInstructions from './ActionInstructions';

interface props {
  integration: Integration;
  editAccount: (accountId: string, action: ActionType) => void;
  onComplete: (accountId: string, action: ActionType) => void;
}

export default function IntegrationBox(props: props) {
  const [action, setAction] = useState<ActionType>('');

  const accountCount = props.integration.accounts.length;
  const accountLimit = props.integration.maxAccounts || 15;
  const allowAdd = accountCount < accountLimit;
  const isSingleAccountMode = !allowAdd && accountCount == 1;
  const addAccountActionType: ActionType = props.integration.accountActions?.includes('Install') ? 'Install' : 'Link';

  const close = () => {
    setAction('');
  };

  const onComplete = (accountId: string, followUpAction?: ActionType) => {
    props.onComplete(accountId, followUpAction);
    close();
  };

  return (
    <P2GBox bordered textAlign="center">
      <P2GBox p={1} filled={props.integration.accounts.length > 0}>
        <P2GImage
          src={`https://content.parcelsolutions.net/42c5534b-0f47-4342-80f0-8f21203f0669/integrations/${props.integration.type}/${props.integration.slug}.svg?v=1`.toLowerCase()}
          style={{ height: '65px', maxWidth: '100%' }}
          alt={props.integration.name}
        />
      </P2GBox>
      <P2GBox pt={1} pb={1}>
        {accountCount > 0 ? (
          <P2GLinkGroup
            links={[
              accountCount < accountLimit && (
                <P2GLink onClick={() => setAction(addAccountActionType)}>Link Account</P2GLink>
              ),
              <P2GLink onClick={() => setAction('AccountList')}>Manage</P2GLink>,
            ]}
          />
        ) : (
          <P2GLinkGroup
            links={[allowAdd && <P2GLink onClick={() => setAction(addAccountActionType)}>Link Account</P2GLink>]}
          />
        )}
        <P2GSidePanel
          open={!!action}
          onClose={close}
          anchor="right"
          width={'700px'}
          title={
            action === 'AccountList'
              ? `${props.integration.name} Accounts`
              : `${action} ${props.integration.name} Account`
          }>
          {action &&
            (action === addAccountActionType ? (
              <ActionInstructions
                configRequired={false}
                action={action}
                integrationSlug={props.integration.slug}
                integrationType={props.integration.type}
                onComplete={onComplete}
                accountId={null}
              />
            ) : (
              <IntegrationAccountsAndActions
                mainActionType={addAccountActionType}
                allowAdd={allowAdd}
                isSingleAccountMode={isSingleAccountMode}
                accountLimit={accountLimit}
                accountCount={accountCount}
                addAccount={() => setAction(addAccountActionType)}
                integration={props.integration}
                close={close}
                editAccount={props.editAccount}
              />
            ))}
        </P2GSidePanel>
      </P2GBox>
    </P2GBox>
  );
}
